// extracted by mini-css-extract-plugin
module.exports = {"nounbrWrapper":"Auction_nounbrWrapper__aliJT","nounbrContentCol":"Auction_nounbrContentCol__1n8CE","auctionActivityCol":"Auction_auctionActivityCol__3U2jw"};